import { AppointmentTimeTracking, OpenSessions, TimeTrackingEvent } from "../types/event";

import ApiService from "./ApiService";

type GetTimeTrackingEventsByAppointmentIdResponse = {
  data: TimeTrackingEvent[];
};

type GetTotalTimeByResponse = {
  data: {
    firstEvent: TimeTrackingEvent;
    lastEvent: TimeTrackingEvent;
    totalSeconds: number;
    totalSecondsIncludingOpen: number;
    status: string;
    isRunning: boolean;
    isPaused: boolean;
    openSince: string | null;
  };
};

type GetTimesheetByAppointmentResponse = {
  data: AppointmentTimeTracking;
};

type GetOpenSessionsByEmployeeResponse = {
  data: OpenSessions;
};  

export const TrackingEventService = {
  GetAllByAppointment: async (
    appointmentId: string
  ): Promise<GetTimeTrackingEventsByAppointmentIdResponse> => {
    return ApiService.Get(`time-tracking/events/appointment/${appointmentId}`);
  },
  GetAllByEmployee: async (
    employeeId: string
  ): Promise<GetTimeTrackingEventsByAppointmentIdResponse> => {
    return ApiService.Get(`time-tracking/events/employee/${employeeId}`, {
      sort: "-eventTimestamp",
    });
  },
  GetTotalTimeByAppointment: async (
    appointmentId: string
  ): Promise<GetTotalTimeByResponse> => {
    return ApiService.Get(
      `time-tracking/events/appointment/${appointmentId}/total`
    );
  },
  GetTotalTimeByAppointmentPerEmployeeId: async (
    appointmentId: string,
    employeeId: string
  ): Promise<GetTotalTimeByResponse> => {
    return ApiService.Get(
      `time-tracking/events/appointment/${appointmentId}/employee/${employeeId}/total`
    );
  },
  DeleteTimeTracking: async (timeTrackingId: string): Promise<object> => {
    return ApiService.Delete(timeTrackingId, "time-tracking/events");
  },
  GetTimeTrackingTimesheetByAppointment: async (
    appointmentId: string
  ): Promise<GetTimesheetByAppointmentResponse> => {
    return ApiService.Get(
      `time-tracking/timesheet/appointment/${appointmentId}`
    );
  },
  GetOpenSessionsByEmployee: async (
    employeeId: string
  ): Promise<GetOpenSessionsByEmployeeResponse> => {
    return ApiService.Get(`time-tracking/employee/${employeeId}/status`);
  },
};
